import { Year } from "@js-joda/core"

const CopyRightsFooter = () => (
  <p className="py-6 text-center text-sm text-primary-contrast">
    © {Year.now().value()} <strong>Bloomlife</strong>, all rights reserved.
  </p>
)

export default CopyRightsFooter
